import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const playResponsiblySchema = z.object({
  ['modifica-limiti-ricarica']: z.boolean().optional(),
  validateDoc: z.boolean().optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_full_navigation/responsible-gaming',
)({ validateSearch: zodValidator(playResponsiblySchema) });
